import React from 'react';

interface InstagramProfileViewProps {
  userInfo: {
    username?: string;
    name?: string;
    profile_picture_url?: string;
    followers_count?: number;
    follows_count?: number;
    media_count?: number;
  };
}

const InstagramProfileView: React.FC<InstagramProfileViewProps> = ({ userInfo }) => {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-[#2a2a2a] rounded-2xl border border-gray-700 overflow-hidden">
        {/* Profile Header */}
        <div className="relative h-32 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-600"></div>

        {/* Profile Picture */}
        <div className="relative px-6 pb-6">
          <div className="absolute -top-16 left-6">
            <div className="w-24 h-24 rounded-full border-4 border-[#2a2a2a] bg-gray-700 overflow-hidden">
              {userInfo.profile_picture_url ? (
                <img
                  src={userInfo.profile_picture_url}
                  alt={userInfo.username}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-600">
                  <span className="text-white text-3xl font-bold">
                    {userInfo.username?.charAt(0).toUpperCase()}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Profile Info */}
          <div className="pt-12">
            <div className="flex items-center gap-2 mb-1">
              <h2 className="text-white text-2xl font-semibold">
                {userInfo.name || userInfo.username}
              </h2>
            </div>
            <p className="text-gray-400 text-sm mb-6">@{userInfo.username}</p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mb-6">
              <div className="text-center">
                <p className="text-white text-lg font-semibold">{userInfo.followers_count || 0}</p>
                <p className="text-gray-400 text-xs">Followers</p>
              </div>
              <div className="text-center">
                <p className="text-white text-lg font-semibold">{userInfo.follows_count || 0}</p>
                <p className="text-gray-400 text-xs">Following</p>
              </div>
              <div className="text-center">
                <p className="text-white text-lg font-semibold">{userInfo.media_count || 0}</p>
                <p className="text-gray-400 text-xs">Posts</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstagramProfileView;
